/**
 * Resolve the hidden MagNano pricing variant from its option names.
 * Supports the legacy two-option product during catalog/cache rollout.
 */
(function (root, factory) {
  'use strict';

  var api = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.theme = root.theme || {};
    root.theme.magnanoTier = api;
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function normalize(value) {
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function optionName(option) {
    if (typeof option === 'string') return option;
    return option && option.name ? option.name : '';
  }

  function isCountName(value) {
    var name = normalize(value);
    if (name.indexOf('pocket') !== -1) return false;
    return name.indexOf('case count') !== -1
      || name.indexOf('case quantity') !== -1
      || name.indexOf('bundle quantity') !== -1
      || name.indexOf('count') !== -1
      || name.indexOf('quantity') !== -1;
  }

  function isPocketName(value) {
    return normalize(value).indexOf('pocket') !== -1;
  }

  function isSizeName(value) {
    return normalize(value).indexOf('size') !== -1;
  }

  function findOptionIndex(product, matcher) {
    var options = product && Array.isArray(product.options) ? product.options : [];
    for (var i = 0; i < options.length; i++) {
      if (matcher(optionName(options[i]))) return i;
    }
    return -1;
  }

  function variantValue(variant, index) {
    if (!variant || index < 0) return '';
    if (Array.isArray(variant.options)) return variant.options[index] || '';
    return variant['option' + (index + 1)] || '';
  }

  function firstNumber(value) {
    var match = String(value == null ? '' : value).match(/(\d+)/);
    return match ? parseInt(match[1], 10) || 0 : 0;
  }

  function sizeKey(value) {
    var size = normalize(value).replace(/[^a-z0-9]+/g, ' ');
    if (size.indexOf('vitamin xl') !== -1 || size.indexOf('xl vitamin') !== -1) return 'vitamin-xl';
    if (size.indexOf('vitamin') !== -1) return 'vitamin';
    if (size.indexOf('pill') !== -1) return 'pill';
    return size.trim();
  }

  function findVariant(product, selection) {
    if (!product || !Array.isArray(product.variants)) return null;

    var count = parseInt(selection && selection.caseCount, 10) || 0;
    var pockets = parseInt(selection && selection.pocketCount, 10) || 0;
    var selectedSize = selection && selection.caseSize;
    var countIndex = findOptionIndex(product, isCountName);
    var pocketIndex = findOptionIndex(product, isPocketName);
    var sizeIndex = findOptionIndex(product, isSizeName);

    if (!count || !pockets || countIndex < 0 || pocketIndex < 0) return null;
    if (sizeIndex >= 0 && !String(selectedSize || '').trim()) return null;

    var expectedSize = sizeKey(selectedSize);
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (firstNumber(variantValue(variant, countIndex)) !== count) continue;
      if (firstNumber(variantValue(variant, pocketIndex)) !== pockets) continue;
      if (sizeIndex >= 0 && sizeKey(variantValue(variant, sizeIndex)) !== expectedSize) continue;
      return variant;
    }

    return null;
  }

  return {
    findVariant: findVariant,
    sizeKey: sizeKey
  };
});
